// components
import GridPageAbstract from '../../abstract/GridPageAbstract';
import { currencyConfig } from '../../../config/currency.config';
import { mergeHeadWithStorage } from '../../../utils/gridHeadStorage';
import { getModifiedBy } from '../../../utils/cells';

export default class AccountingGatewayAccountsPage extends GridPageAbstract {
    constructor(props) {
        super(props);
        this.Name = 'accountingGatewayAccounts';
        this.Server = this.props.context.getState().server.accountingGatewayAccounts;
        this.MenuDisplayType = 'menu';
        this.searchFields = ['name'];

        //create table public.gateway_accounts
        // (
        //     id            serial
        //         constraint gateway_accounts_pk
        //             primary key,
        //     name          varchar,
        //     currency      varchar,
        //     api_balance   integer,
        //     api_sync_date timestamp
        // );
        //
        // alter table public.gateway_accounts
        //     add gateway_settings_id integer
        //         constraint gateway_accounts_gateway_settings_id_fk
        //             references public.gateway_settings;

        const defaultHead = [
            {
                id: 'name',
                label: 'name',
                alignRight: false,
                cell: 'Text',
                displayGrid: true
            },
            {
                id: 'currency',
                label: 'currency',
                alignRight: false,
                cell: 'Items',
                type: 'currency',
                noTranslate: true,
                items: Object.keys(currencyConfig),
                displayGrid: true
            },
            {
                id: 'apiBalance',
                label: 'apiBalance',
                alignRight: false,
                cell: 'Amount',
                displayGrid: true,
                disableEditor: true
            },
            {
                id: 'balance',
                label: 'balance',
                alignRight: false,
                cell: 'Amount',
                displayGrid: true,
                disableEditor: true
            },
            {
                id: 'apiSyncDate',
                label: 'apiSyncDate',
                alignRight: false,
                cell: 'Date',
                displayGrid: true,
                disableEditor: true
            },
            {
                id: 'gatewaySettingsId',
                label: 'gatewaySettings',
                alignRight: false,
                cell: 'Select',
                from: 'publicGatewaySettings',
                show: 'templateName',
                object: 'gatewaySetting',
                displayGrid: true
            },
            {
                id: 'modifiedReason',
                label: 'modifiedReason',
                alignRight: false,
                cell: 'BigText',
                displayGrid: true,
                disableEditor: true,
                extraRender: (value, row) => getModifiedBy(row)
            }
            // {
            //     id: 'dateCreatedModified',
            //     elements: ['dateCreated', 'dateModified'],
            //     label: 'dateCreatedModified',
            //     alignRight: false,
            //     cell: 'CreateModify',
            //     disableEditor: true,
            //     displayGrid: true,
            //     customSort: 'dateCreated',
            // },
        ];

        this.Head = mergeHeadWithStorage(this.Name, defaultHead);

        this.state = {
            ...this.state,
            head: this.Head
        };
    }
}
